import _ from 'lodash';
import React, { Component } from 'react';

import Select from 'react-select';

import {
  getOptionValueForSelect,
  getDimensionFamilies,
  getDimensionFromId,
} from '../../util';

class DimensionFamilySelect extends Component {

  state = {

  }

  dimensionFamilyOptions(){
    const sortedDimensionFamilies = _.sortBy(getDimensionFamilies(), 'label');

    return _.map(sortedDimensionFamilies, ({id, label, allDimensions}) => {

      const dimensionDataForFamily = _.map(allDimensions, getDimensionFromId);

      return {
        value: id,
        label: `${label} (${_.map(dimensionDataForFamily, 'label').join(', ')})`
      }
    });
  }

  render(){

    const { currentDimensionFamily } = this.props;

    return (
      <div
        style={this.props.style || {}}
        className={`dimension-family-select-container`}
      >
        <Select
          isDisabled={this.props.disabled || false}
          classNamePrefix={'react-select'}
          className={`react-select-container dimension-family-select`}
          value={getOptionValueForSelect(this.dimensionFamilyOptions(), currentDimensionFamily)}
          options={this.dimensionFamilyOptions()}
          onChange={(option) => { this.props.changeDimensionFamily(option.value); }}
          isSearchable={true}
        />
      </div>
    )
  }
}
export default DimensionFamilySelect;



// WEBPACK FOOTER //
// ./src/components/shared/dimensionFamilySelect.js